import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';

type CustomQueue = {
  name: string;
};

function fetchCustomQueue() {
  return get<CustomQueue>('/api/organization/custom-provided-builds-queue');
}

export const getCustomQueueQueryKey = (): QueryKey => ['organization', 'customProvidedBuildsQueue'];

/**
 * Hook to fetch the custom provided builds queue for the current organization.
 * @returns Query result containing the custom queue configuration
 */
export const useCustomProvidedBuildsQueue = () => {
  return useQuery<CustomQueue>({
    queryKey: getCustomQueueQueryKey(),
    queryFn: fetchCustomQueue,
    staleTime: 600_000, // Cache for 10 minutes, this really shouldn't change very often
  });
};
